<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div class="section-title">{{ $tc("translations") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("manage_translation") }}
        </div>
      </div>
      <div style="">
        <b-pagination
          v-if="rows > 0"
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
        />
      </div>
      <div></div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex align-items-center justify-content-start">
        <b-form-input
          @input="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        />
      </div>
      <div class="d-flex align-items-center">
        <div
          v-if="translationList && translationList.length > 0"
          class="d-flex justify-content-end mb-2 align-items-center"
        >
          <!-- <div>{{ $t("download") }} as :</div> -->
          <a
            :href="BASE_URL + `${this.reportUrl}${'active'}`"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
              class="mx-1"
              v-b-tooltip.hover.top="'Download As Excel'"
            />
          </a>
        </div>
        <b-dropdown name="listview" id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- Viewing&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div
      class="table-grid-92"
      v-if="translationList && translationList.length > 0"
    >
      <div class="table-scroll">
        <table class="list-view-table">
          <thead>
            <tr class="table-grid-row">
              <th class="text-left">
                <span class="">{{ $tc("STAT", 2) }}</span>
              </th>
              <th class="w-1">
                <div class="d-flex">
                  <img
                    v-if="this.columnName != 'translation_id'"
                    @click="onSortValue('translation_id', 'asc')"
                    src="@/assets/img/icons/updown.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else-if="isSort && isAscending"
                    @click="onSortValue('translation_id', 'asc')"
                    src="@/assets/img/icons/asc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else
                    @click="onSortValue('translation_id', 'desc')"
                    src="@/assets/img/icons/desc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />

                  {{ "Translation Id" }}
                </div>
              </th>
              <th class="w-1">
                <div class="d-flex">
                  <img
                    v-if="this.columnName != 'module'"
                    @click="onSortValue('module', 'asc')"
                    src="@/assets/img/icons/updown.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else-if="isSort && isAscending"
                    @click="onSortValue('module', 'asc')"
                    src="@/assets/img/icons/asc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else
                    @click="onSortValue('module', 'desc')"
                    src="@/assets/img/icons/desc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  Module
                </div>
              </th>

              <th class="w-1">
                <div class="d-flex">
                  <img
                    v-if="this.columnName != 'category'"
                    @click="onSortValue('category', 'asc')"
                    src="@/assets/img/icons/updown.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else-if="isSort && isAscending"
                    @click="onSortValue('category', 'asc')"
                    src="@/assets/img/icons/asc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else
                    @click="onSortValue('category', 'desc')"
                    src="@/assets/img/icons/desc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  Category
                </div>
              </th>

              <th class="w-2">
                <div class="d-flex">
                  <img
                    v-if="this.columnName != 'key'"
                    @click="onSortValue('key', 'asc')"
                    src="@/assets/img/icons/updown.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else-if="isSort && isAscending"
                    @click="onSortValue('key', 'asc')"
                    src="@/assets/img/icons/asc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  <img
                    v-else
                    @click="onSortValue('key', 'desc')"
                    src="@/assets/img/icons/desc.svg"
                    class="cursor-pointer"
                    width="15px"
                    height="20px"
                  />
                  Key
                </div>
              </th>
              <th class="w-2" v-if="checkAvailableLang('en')">
                <div class="d-flex">en</div>
              </th>
              <th class="w-2" v-if="checkAvailableLang('de')">
                <div class="d-flex">
                  {{ "de" }}
                </div>
              </th>
              <th class="w-2" v-if="checkAvailableLang('fr')">
                <div class="d-flex">
                  {{ "fr" }}
                </div>
              </th>
              <th class="w-2" v-if="checkAvailableLang('it')">
                <div class="d-flex">
                  {{ "it" }}
                </div>
              </th>

              <th v-for="(item, key) in extraLangs" class="w-2">
                {{ String(item.iso_2).toLowerCase() }}
              </th>
              <th class="w-2">{{ "Remark" }}</th>
            </tr>
          </thead>
          <template v-if="translationList && translationList.length > 0">
            <tbody>
              <tr
                v-for="(item, key) in translationList"
                :key="key"
                class="table-grid-row"
              >
                <td>
                  <div class="d-flex align-items-center justify-content-start">
                    <StatusDot
                      :status="item.is_active === 'Y' ? 'active' : 'inactive'"
                    />
                    <div
                      v-if="$can('update', 'Translations')"
                      class="edit-pen blue-icon ml-3 btn"
                      style="cursor: pointer"
                      @click="goToRoute('Edit Translation', item)"
                      v-b-tooltip="'Edit'"
                      tabindex="0"
                    ></div>
                  </div>
                </td>
                <td class="w-1 td text-center">
                  <span class="text-truncate">{{ item.translation_id }}</span>
                </td>
                <td class="w-1 td ml-2">
                  <span class="text-truncate">{{ item.module }}</span>
                </td>
                <td class="w-1 td">
                  <span class="text-truncate">{{ item.category }}</span>
                </td>
                <td class="w-2 td">
                  <span class="text-truncate">{{ item.key }}</span>
                </td>
                <td class="w-2 td" v-if="checkAvailableLang('en')">
                  <span class="text-truncate">{{ item.en }}</span>
                </td>
                <td class="w-2 td" v-if="checkAvailableLang('de')">
                  <span class="text-truncate">{{ item.de }}</span>
                </td>
                <td class="w-2 td" v-if="checkAvailableLang('fr')">
                  <span class="text-truncate">{{ item.fr }}</span>
                </td>
                <td class="w-2 td" v-if="checkAvailableLang('it')">
                  <span class="text-truncate">{{ item.it }}</span>
                </td>

                <td class="w-2 td" v-for="(lang, key) in extraLangs">
                  <span class="text-truncate">{{
                    item["extraLangs"][String(lang.iso_2).toLowerCase()]
                  }}</span>
                </td>

                <td class="w-2 td">
                  <span class="text-truncate">{{ item.remark }}</span>
                </td>
              </tr>
            </tbody>
          </template>
        </table>
      </div>
      <!-- <div>
        <div class="">
          <table class="list-view-table status-table mb-2 table-grid-row">
            <thead>
              <tr>
                <th class="">
                  <span class="">{{ $tc("STAT", 2) }}</span>
                </th>
              </tr>
            </thead>
            <template v-if="translationList && translationList.length > 0">
              <tbody>
                <tr
                  v-for="(item, key) in translationList"
                  :key="key"
                  class="table-grid-row"
                >
                  <td class="px-0">
                    <div
                      class="d-flex align-items-center justify-content-end pb-1"
                    >
                      <StatusDot
                        :status="item.is_active === 'Y' ? 'active' : 'inactive'"
                      />
                      <div
                        v-if="$can('update', 'Translations')"
                        class="edit-pen blue-icon ml-3 btn"
                        style="cursor: pointer"
                        @click="goToRoute('Edit Translation', item)"
                      ></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </table>
        </div>
      </div> -->
    </div>
    <div v-else>
      <table class="list-view-table">
        <thead>
          <tr class="table-grid-row">
            <th class="" colspan="2">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'translation_id'"
                  @click="onSortValue('translation_id', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('translation_id', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('translation_id', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />

                {{ "Translation Id" }}
              </div>
            </th>
            <th class="">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'module'"
                  @click="onSortValue('module', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('module', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('module', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                Module
              </div>
            </th>

            <th class="">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'category'"
                  @click="onSortValue('category', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('category', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('category', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                Category
              </div>
            </th>

            <th class="">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'key'"
                  @click="onSortValue('key', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('key', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('key', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                Key
              </div>
            </th>
            <th class="" v-if="checkAvailableLang('en')">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'en'"
                  @click="onSortValue('en', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('en', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('en', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                en
              </div>
            </th>
            <th class="" v-if="checkAvailableLang('de')">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'de'"
                  @click="onSortValue('de', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('de', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('de', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ "de" }}
              </div>
            </th>
            <th class="" v-if="checkAvailableLang('fr')">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'fr'"
                  @click="onSortValue('fr', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('fr', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('fr', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ "fr" }}
              </div>
            </th>
            <th class="" v-if="checkAvailableLang('it')">
              <div class="d-flex">
                <img
                  v-if="this.columnName != 'it'"
                  @click="onSortValue('it', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('it', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('it', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ "it" }}
              </div>
            </th>
            <th class="">{{ "Remark" }}</th>
            <th class="">
              <span class="">{{ $tc("STAT", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-grid-row">
            <td colspan="11">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import draggable from "vuedraggable";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import _ from "lodash";
export default {
  components: {
    draggable,
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      reportUrl: "/api/admin/getTranslationsExport?status=",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      bannerlist: [],
      translationList: [],
      extraLangs: [],
      cinema_id: null,
      searchValue: "",
      isSort: false,
      isAscending: true,
      orderby: "asc",
      columnName: "",

      isEditable: false,
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active" },
        { status: "Inactive" },
        { status: "All" },
      ],
      selectedStatus: "Active",
      ContentLanguages: [],
      debounce: null,
    };
  },
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const currentPageFromUrl = parseInt(newVal.currentPage) || 1;
        const currentSearchFromUrl = newVal.searchValue;
        const currentperPageFromUrl = newVal.perPage;

        this.$nextTick(() => {
          if (!!currentPageFromUrl) {
            this.currentPage = parseInt(currentPageFromUrl);
          }
          if (!!currentSearchFromUrl) {
            this.searchValue = currentSearchFromUrl;
          } else {
            this.searchValue = "";
          }
          if (!!currentperPageFromUrl) {
            this.perPage = currentperPageFromUrl;
          }

          if (!_.isEqual(newVal, oldVal)) {
            this.getAllTranslations({
              perPage: this.perPage,
            });
          }
        });
      },
      immediate: true,
    },
  },
  beforeMount() {
    this.getContentLangauge();
  },
  mounted() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id || null;
    // this.getBannerList();
    this.getviewingnumber();
    // this.getAllTranslations({
    //   perPage: this.perPage,
    //   currentPage: this.currentPage
    // });
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    checkAvailableLang(iso_2) {
      let tempArray = [];
      tempArray = this.ContentLanguages.filter(
        (x) => x.iso_2.toLowerCase() == iso_2.toLowerCase()
      );
      if (tempArray.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    getContentLangauge: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              this.ContentLanguages = data.ContentLanguages;
            }
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {});
    },
    endSort(event) {
      this.bannerlist.map((x, index) => {
        if (this.currentPage != 1) {
          x.b_order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.b_order = index + 1;
        }
      });
      console.log("this.sorted banner", this.bannerlist);
      console.log("this.event", event);
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.getBannerList();
    },
    getAllTranslations(payload) {
      let apiPayload = {
        ...payload,
      };
      if (!!this.$route.query.currentPage) {
        apiPayload.currentPage = this.$route.query.currentPage;
      }
      if (!!this.$route.query.searchValue) {
        apiPayload.search = this.$route.query.searchValue;
      }
      if (!apiPayload.search) {
        apiPayload.search = "";
      }
      if (!!this.$route.query.perPage) {
        apiPayload.perPage = this.$route.query.perPage;
      }

      let loader = this.$loading.show();
      MasterService.GetAllTranslations(apiPayload)
        .then((res) => {
          this.translationList = res.data.Records.data;
          this.extraLangs = res.data.extraLangs || [];
          if (!apiPayload.pagination)
            this.rows = res.data.Records.pagination.total;

          this.currentPage = res.data.Records.pagination.currentPage;

          if (res.data && res.data.Records && res.data.Records.totalRows >= 0) {
            this.rows = res.data.Records.totalRows;
            if (res.data.Records.totalRows < 10) {
              this.selectedvalue = res.data.Records.totalRows;
            }
          }
        })
        .finally((_) => {
          setTimeout(() => loader.hide(), 0);
          this.$forceUpdate();
        });
    },
    isBannerEditable: function () {
      this.isEditable = true;
      let active_rating = [];
      if (this.isEditable) {
        this.filterButtonTitle = "Active";
        this.selectedStatus = "Active";
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      let q = { ...this.$route.query };
      let perPagevalue = this.rows;
      if (event !== "All") {
        perPagevalue = event;
      }

      this.$router
        .push({
          query: { ...q, perPage: !!perPagevalue ? perPagevalue : undefined },
        })
        .catch(() => {})
        .finally(() => {
          if (event == "All") {
            this.perPage = this.rows;
            this.selectedvalue = event;
            this.onChangePagination();
          } else {
            console.log("Numbers :", event);
            this.selectedvalue = event;
            this.perPage = event;
            console.log("perPage :", this.perPage);
            this.onChangePagination();
          }
        });
    },

    onChangePagination(event) {
      this.$router
        .push({
          query: { ...this.$route.query, currentPage: !!event ? event : 1 },
        })
        .catch(() => {})
        .finally((_) => {
          console.log("event :>> ", event);
          if (event === undefined) {
            this.currentPage = 1;
            // this.getBannerList();
            // this.getAllTranslations({
            //   perPage: this.perPage,
            //   currentPage: this.currentPage,
            //   pagination: true,
            //   search: this.searchValue
            // });
          } else {
            this.currentPage = event;
            // this.getAllTranslations({
            //   perPage: this.perPage,
            //   currentPage: this.currentPage,
            //   pagination: true,
            //   search: this.searchValue
            // });
          }
        });
    },
    onSearch(event) {
      let q = {
        ...this.$route.query,
        searchValue: !!event ? event : undefined,
        currentPage: "1",
        perPage: "10",
      };

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$router
          .push({ query: q })
          .catch(() => {})
          .finally((_) => {
            if (!!event) this.searchValue = event;
            else this.searchValue = "";

            // this.getAllTranslations({
            //   perPage: this.perPage,
            //   currentPage: this.currentPage,
            //   search: this.searchValue
            // });
          });
      }, 800);
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getAllTranslations({
        perPage: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      });
    },
    getBannerList() {
      // this.bannerlist = [];
      MasterService.GetMasterBanners({
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.cinema_id,
        search: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        status: this.selectedStatus,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.bannerlist = data.Records;
            this.bannerlistCopy = data.Records;
            if (data.totalRows >= 10) {
              // this.rows = data.totalRows;
            } else {
              // this.rows = data.totalRows;
              // this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    updateBannerOrder: function () {
      this.isEditable = false;
      let payload = {
        Banners: this.bannerlist,
      };
      console.log("In update section", this.bannerlist);
      MasterService.UpdateBannerOrder(payload)
        .then((data) => {
          console.log("data", data);
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToRoute: function (name, translation) {
      this.$router.push({
        name: name,
        params: {
          t_id: translation.translation_id,
        },
      });
    },
  },
};
</script>
<style>
.cinema_col {
  display: inline-block;
  width: 180px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.td {
  overflow: hidden;
}
.table-grid-row td.w-1 {
  width: 150px;
  display: inline-grid;
}
.table-grid-row th.w-1 {
  width: 150px;
  display: inline-grid;
}
.table-grid-row td.w-2 {
  width: 200px;
  display: inline-grid;
}
.table-grid-row th.w-2 {
  width: 200px;
  display: inline-grid;
}
.status-table.table-grid-row td {
  height: 29px;
  display: inline-grid;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TranslationsComponent/TranslationsList.vue